import type { IconSvgObject } from './types';

const ArrowUpToLineIcon: IconSvgObject = [
  ["path", { d: "M7 12L12 7L17 12M12 8L12 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 3L18 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUpToLineIcon;
